class ForecastDayPartModel {
  constructor(properties) {
    this.hour = properties.hour;
    this.descriptor = properties.descriptor;
    this.maximumTemperature = properties.maximumTemperature;
    this.minimumHumidity = properties.minimumHumidity;
    this.minimumTemperature = properties.minimumTemperature;
    this.precipitationAmount = properties.precipitationAmount;
    this.precipitationChance = properties.precipitationChance;
    this.predictedEvapotranspiration = properties.predictedEvapotranspiration;
    this.windDirection = properties.windDirection;
    this.windSpeed = properties.windSpeed;
  }
}

export default ForecastDayPartModel;
